export const projectCategories = [
  'All',
  'AI & Machine Learning',
  'Full-Stack',
  'Systems & Libraries',
  'Game Dev'
];

export const projects = [
  {
    id: 'sentinel',
    title: 'Sentinel',
    subtitle: 'Autonomous Security Intelligence & Threat Detection Agent',
    description: 'Autonomous security monitoring and threat intelligence platform leveraging real-time anomaly detection, rule synthesis, and automated incident triage for vulnerability surveillance.',
    tags: ['Python', 'AI Agents', 'Security', 'FastAPI', 'Threat Intel', 'Real-time Telemetry'],
    category: 'AI & Machine Learning',
    repoUrl: 'https://github.com/Anaji00/Sentinel',
    liveUrl: null,
    featured: true,
    badge: 'New & Featured'
  },
  {
    id: 'market-maker',
    title: 'MarketMaker',
    subtitle: 'Agentic AI Trading Signals & Market Intelligence',
    description: 'AI-driven market signal and analysis platform that delivers real-time quantitative insights, anomaly detection alerts via Isolation Forest, and actionable guidance across equities and crypto.',
    tags: ['Python', 'AI Agents', 'Isolation Forest', 'Quantitative Finance', 'FastAPI', 'Market Analytics'],
    category: 'AI & Machine Learning',
    repoUrl: 'https://github.com/Anaji00/MarketMaker',
    liveUrl: null,
    featured: true,
    badge: 'Featured'
  },
  {
    id: 'uknowball',
    title: 'UKNOWBALL',
    subtitle: 'NBA Player Predictive Analytics & ML Pipeline',
    description: 'Production-grade ML pipeline combining XGBoost and Deep Multi-Layer Perceptrons (MLP) to forecast NBA player performance metrics, feature-engineered from decades of historical telemetry.',
    tags: ['Python', 'XGBoost', 'PyTorch', 'Data Engineering', 'ML Pipeline', 'Scikit-learn'],
    category: 'AI & Machine Learning',
    repoUrl: 'https://github.com/Anaji00/UKNOWBALL',
    liveUrl: null,
    featured: true,
    badge: 'Featured'
  },
  {
    id: 'debate-ai',
    title: 'DebateAI',
    subtitle: 'Historical Figure Chatbot & Rhetoric Trainer',
    description: 'Interactive conversational debate platform connecting users against persona-prompted historical figures. Features streaming LLM completions, real-time counter-argument evaluation, and CI/CD automation.',
    tags: ['FastAPI', 'React', 'LLM Prompting', 'Python', 'Tailwind CSS', 'CI/CD'],
    category: 'AI & Machine Learning',
    repoUrl: 'https://github.com/Anaji00/debateai-frontend',
    liveUrl: null,
    featured: true,
    badge: 'Featured'
  },
  {
    id: 'functools2',
    title: 'functools2',
    subtitle: 'Async LRU Cache Library for Python (PyPI)',
    description: 'An asyncio-native caching library offering TTL expiration, single-flight stampede mitigation, and stale-while-revalidate patterns to safely accelerate async routines across Python web servers.',
    tags: ['Python', 'asyncio', 'PyPI Package', 'Caching', 'Concurrency', 'LRU'],
    category: 'Systems & Libraries',
    repoUrl: 'https://github.com/Anaji00/functools2',
    liveUrl: 'https://pypi.org/project/functools2/',
    featured: false,
    badge: 'PyPI Package'
  },
  {
    id: 'track-apply',
    title: 'TrackApply',
    subtitle: 'Full-Stack Job Application Lifecycle Platform',
    description: 'Robust application management suite with ASP.NET Core Web API, Angular frontend, secure JWT authentication, role-based access controls, and SQLite database persistence.',
    tags: ['ASP.NET Core', 'Angular', 'C#', 'TypeScript', 'JWT Auth', 'SQLite', 'REST API'],
    category: 'Full-Stack',
    repoUrl: 'https://github.com/Anaji00/TrackApply',
    liveUrl: null,
    featured: false,
    badge: null
  },
  {
    id: 'fabled-knights',
    title: 'FabledKnights',
    subtitle: '2.5D Action RPG & Combat Engine',
    description: 'Side-scrolling action-adventure title engineered in Unity (C#) featuring custom melee state machines, particle animation controllers, and procedural dungeon encounters.',
    tags: ['Unity', 'C#', 'Game Design', '2.5D Physics', 'State Machines'],
    category: 'Game Dev',
    repoUrl: 'https://github.com/Anaji00/FabledKnights',
    liveUrl: null,
    featured: false,
    badge: null
  },
  {
    id: 'music-r-us',
    title: 'Music-R-Us',
    subtitle: 'End-to-End E-Commerce Platform',
    description: 'Full-stack retail platform for instruments and audio equipment featuring responsive product catalogs, persistent shopping cart sessions, customer checkouts, and admin CRUD portal.',
    tags: ['Full-Stack', 'JavaScript', 'E-Commerce', 'Node.js', 'Web Architecture'],
    category: 'Full-Stack',
    repoUrl: 'https://github.com/Anaji00/ECommerce---Music-R-Us',
    liveUrl: null,
    featured: false,
    badge: null
  }
];
